import { use, useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import { deleteWorkshopRegister, getWorkshopRegisters, getWorkshopRegistersBill } from "../../redux/services/workshopRegisterSlice";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";
import { getWorkshops } from "../../redux/services/workshopSlice";
import { PiFilePdf } from "react-icons/pi";

const WorkshopRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getRegisterData = useSelector((state) => state?.workshopRegister?.workshopRegisterData);
  const getWorkshopData = useSelector((state) => state?.workshop?.workshopData?.workshop_data);
  const getWorkshopBill = useSelector((state) => state?.workshopRegister?.workshopRegisterBillData);

  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const [workshopFilter, setWorkshopFilter] = useState("");
  const [workshopBill, setWorkshopBill] = useState("");

  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

  const getAllWorkshops = useCallback(async () => {
    try {
      await dispatch(getWorkshops({ page: page + 1, limit: pageLimit, searchData }));
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllWorkshops();
  }, [getAllWorkshops]);

  const filterOptions = [
    { value: "", label: "All" },
    ...(getWorkshopData
      ? getWorkshopData?.map((workshop) => ({
          value: workshop?._id,
          label: workshop?.title,
        }))
      : ""),
  ];

  const getAllRegisters = useCallback(async () => {
    try {
      await dispatch(getWorkshopRegisters({ page: page + 1, limit: pageLimit, searchData, workshopId: workshopFilter }));
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData, workshopFilter]);

  useEffect(() => {
    getAllRegisters();
  }, [getAllRegisters]);

  const deleteRegister = async () => {
    try {
      const response = await dispatch(deleteWorkshopRegister(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllRegisters();
    } catch (error) {}
  };

  const getRegistersBill = useCallback(async () => {
    try {
      await dispatch(getWorkshopRegistersBill({ workshopId: workshopBill }));
    } catch (error) {}
  }, [dispatch, workshopBill]);

  useEffect(() => {
    if (workshopBill) {
      getRegistersBill();
    }
  }, [getRegistersBill, workshopBill]);

  const columns = [
    { header: "S/N", key: "index", render: (_, __, index) => page * pageLimit + index + 1 },
    { header: "Name", key: "name" },
    { header: "Phone", key: "phone" },
    { header: "Email", key: "email" },
    { header: "City", key: "city" },
    { header: "Referral Code", key: "referralCode", render: (referralCode) => (referralCode ? referralCode : "-") },
    { header: "Reach From", key: "reachFrom", render: (reachFrom) => (reachFrom ? reachFrom : "-") },
    { header: "Merchant ID", key: "merchantId" },
    { header: "Payment ID", key: "paymentId" },
    { header: "Status", key: "status" },
    {
      header: "Enroll Date",
      key: "createdAt",
      render: (value) => (value ? new Date(value).toLocaleDateString() : "—"),
    },
    {
      header: "Payment Date",
      key: "paymentDate",
      render: (value) => (value ? new Date(value).toLocaleDateString() : "—"),
    },
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        navigate(`${ROUTES.WORKSHOPS.REGISTER_EDIT}?workshopId=${row._id}`, {
          state: { row },
        });
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
    {
      icon: <PiFilePdf className="w-6 h-6" />,
      onClick: (row) => {
        if (row.billPdfUrl) {
          window.open(row.billPdfUrl, "_blank");
        } else {
          setWorkshopBill(row._id);
        }
      },
    },
  ];
  useEffect(() => {
    if ((getWorkshopBill)) {
      window.open(getWorkshopBill, "_blank");
      setWorkshopBill("");
      getAllRegisters();
    }
  }, [getWorkshopBill]);

  return (
    <>
      <Table
        title="Workshop Register"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        columns={columns}
        data={getRegisterData?.webinar_data || []}
        actions={actions}
        filterOptions={filterOptions}
        onFilterChange={(e) => {
          setWorkshopFilter(e ? e.value : "");
        }}
        pageCount={getRegisterData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
      />
      {confirm && <ConfirmationPage topicName="Workshop Register" confirm={confirm} onDelete={deleteRegister} onCancel={() => setConfirm(false)} />}
    </>
  );
};

export default WorkshopRegister;
